"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenTitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ScreenTitle = function ScreenTitle(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("h4", {
    className: (0, _classnames.default)('text-black tw-label-medium', className)
  }, children);
};
exports.ScreenTitle = ScreenTitle;